import { render, staticRenderFns } from "./CreateMessage.vue?vue&type=template&id=36ebdf88&"
import script from "./CreateMessage.vue?vue&type=script&lang=js&"
export * from "./CreateMessage.vue?vue&type=script&lang=js&"
import style0 from "./CreateMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ebdf88')) {
      api.createRecord('36ebdf88', component.options)
    } else {
      api.reload('36ebdf88', component.options)
    }
    module.hot.accept("./CreateMessage.vue?vue&type=template&id=36ebdf88&", function () {
      api.rerender('36ebdf88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/tabs/document/CreateMessage.vue"
export default component.exports